<div [class.dark-theme]="true" class="fix-action-dialog">
	<mat-dialog-content>
		<div>
			<h3 mat-dialog-title style="color: #ffffff;"><span data-idtest="payment-card-create-dialog-t-9Nh" translate>カード登録</span></h3>
		</div>
		<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate style="font-size: 14px;">
			<div style="margin:16px 0;margin-bottom:8px;" fxLayout="column">
				<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
					<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
						<mat-label><span data-idtest="payment-card-create-dialog-t-3Wd" translate>カード番号</span></mat-label>
						<input data-idtest="payment-card-create-dialog-i-2Bm" #number_field="ngModel" [(ngModel)]="content.number" autocomplete="off" matInput maxlength="16" minlength="14" name="number" placeholder="4242424242424242" required type="text" style="color: #ffffff">
						<mat-hint>14 - 16<span translate>文字</span></mat-hint>
						<mat-error *ngIf="number_field.errors?.['required'];"><span translate>入力してください</span></mat-error>
						<mat-error *ngIf="number_field.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						<mat-error *ngIf="number_field.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
					</mat-form-field>
				</div>
				<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
					<div class="title-content" fxFlex="30" fxFlex.lt-sm="100">
						<div data-idtest="payment-card-create-dialog-t-1Zw" style="font-weight:600;" translate>有効期限</div>
					</div>
					<mat-form-field appearance="outline" fxFlex="33" style="height: 80px;">
						<mat-label><span data-idtest="payment-card-create-dialog-t-8Dt" translate>有効期限(月)</span></mat-label>
						<mat-select data-idtest="payment-card-create-dialog-s-4Lw" #month_select="ngModel" [(ngModel)]="content.exp_month" name="month_select" required style="color: #ffffff">
							<mat-option *ngFor="let month of months" [value]="month">
								{{month}}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="month_select.errors?.['required'];">入力してください</mat-error>
					</mat-form-field>
					<mat-form-field appearance="outline" fxFlex="33" style="height: 80px;">
						<mat-label><span data-idtest="payment-card-create-dialog-t-6Yk" translate>有効期限(年)</span></mat-label>
						<mat-select data-idtest="payment-card-create-dialog-s-4Cj" #year_select="ngModel" [(ngModel)]="content.exp_year" name="year_select" required style="color: #ffffff">
							<mat-option *ngFor="let year of years" [value]="year">
								{{year}}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="year_select.errors?.['required'];">入力してください</mat-error>
					</mat-form-field>
				</div>

				<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
					<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
						<mat-label>cvc</mat-label>
						<input data-idtest="payment-card-create-dialog-i-8Hs" #cvc_field="ngModel" [(ngModel)]="content.cvc" autocomplete="off" matInput maxlength="4" minlength="3" name="cvc" placeholder="123" required type="text" style="color: #ffffff">
						<mat-hint><span data-idtest="payment-card-create-dialog-t-0Tg">3 - 4<span translate>文字</span></span></mat-hint>
						<mat-error *ngIf="cvc_field.errors?.['required'];"><span translate>入力してください</span></mat-error>
						<mat-error *ngIf="cvc_field.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						<mat-error *ngIf="cvc_field.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
					</mat-form-field>
				</div>
			</div>
		</form>
	</mat-dialog-content>
	<mat-dialog-actions fxLayoutAlign="center" fxLayoutAlign.lt-sm="center">
		<div fxFlex="100" fxFlex.lt-sm="100%" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around" fxLayoutAlign.lt-sm="center">
			<button [disabled]="isProgress" color="warn" mat-dialog-close="" mat-stroked-button fxFlex="30%" fxFlex.lt-sm="100%"><span data-idtest="payment-card-create-dialog-t-4Cm" translate>閉じる</span></button>
			<button data-idtest="payment-card-create-dialog-b-1Up" (click)="onAccept()" *ngIf="!form.invalid" [disabled]="form.invalid" color="primary" mat-raised-button fxFlex="30%" fxFlex.lt-sm="100%"><span data-idtest="payment-card-create-dialog-t-1Ae" translate>登録</span></button>
			<button *ngIf="form.invalid" mat-raised-button [disabled]="form.invalid" color="primary" fxFlex="30%" fxFlex.lt-sm="100%"><span data-idtest="payment-card-create-dialog-t-7Wx" translate>登録</span></button>
		</div>
	</mat-dialog-actions>
</div>
